import { useAtom, useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { FilterChipItem } from 'components/ui/FilterChipCarousel/FilterChipCarousel';
import { tripStartDayjsAtom } from 'components/forms/bookingWidget/jotaiStore';
import {
  boatCategoriesManipulatorAtom,
  priceObjectManipulatorAtom,
  boatLengthManipulatorObjectAtom,
  instantBookAtom,
  resetAllFiltersAtom,
  selectedPresetAtom,
  activitiesManipulatorAtom,
  passengersCountAtom,
  boatAmenitiesManipulatorAtom,
  tripDateAtom,
  captainOptionsManipulatorAtom,
} from '../../Filter/filterStore';
import { FilterPreset, FilterSetters } from '../types';
import { applyAllFilters } from '../utils';
import useFilterPresetClickTracking from './useFilterPresetClickTracking';

const useFilterSetters = (): FilterSetters => ({
  setBoatCategories: useSetAtom(boatCategoriesManipulatorAtom),
  setPriceRange: useSetAtom(priceObjectManipulatorAtom),
  setLengthRange: useSetAtom(boatLengthManipulatorObjectAtom),
  setInstantBook: useSetAtom(instantBookAtom),
  setActivities: useSetAtom(activitiesManipulatorAtom),
  setPassengers: useSetAtom(passengersCountAtom),
  setAmenities: useSetAtom(boatAmenitiesManipulatorAtom),
  setTripStartAtom: useSetAtom(tripStartDayjsAtom),
  setDateAtom: useSetAtom(tripDateAtom),
  setCaptainOption: useSetAtom(captainOptionsManipulatorAtom),
});

const usePresetHandleClick = (onPresetApplied?: (preset: FilterPreset) => void) => {
  const [selectedPreset, setSelectedPreset] = useAtom(selectedPresetAtom);
  const resetFilters = useResetAtom(resetAllFiltersAtom);
  const filterSetters = useFilterSetters();

  // hook for tracking click event
  const { triggerTracking } = useFilterPresetClickTracking();

  const handlePresetClick = (item: FilterChipItem, index: number): void => {
    const preset = item.value as FilterPreset;

    resetFilters();

    triggerTracking(preset, index + 1);

    if (selectedPreset === preset.id) {
      setSelectedPreset('');
      return;
    }

    applyAllFilters(filterSetters, preset.filters);
    setSelectedPreset(preset.id);
    onPresetApplied?.(preset);
  };

  return { selectedPreset, handlePresetClick };
};

export default usePresetHandleClick;
